module.exports = __webpack_public_path__ + "static/media/logomarca-dommus-mm-login.0be1b55d.svg";